import { render, staticRenderFns } from "./mentionNotificationItem.vue?vue&type=template&id=aab28970"
import script from "./mentionNotificationItem.vue?vue&type=script&lang=ts"
export * from "./mentionNotificationItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports